/**
 * Cross-component event names for the Diagnosis section. Kept in a standalone
 * module (no default export, no hooks) so imports don't accidentally pull in
 * the Diagnosis component — see chiefComplaints/events.js for why.
 */
export const DX_V2_REFRESH = "dx-v2:refresh";

// Content -> editor rail: open a blank "Add diagnosis" form.
export const DX_V2_ADD = "dx-v2:add";

// Content -> editor rail: open the "Update · <name>" form for a row, seeded
// from that record. Payload `{ diagnosis }`. The rail owns both halves of the
// write surface now — the centred UpdateStatusModal is gone.
export const DX_V2_STATUS = "dx-v2:status";

// Transcript-mode content -> transcript modal's own cards column: re-edit
// a captured item that's already been staged during this call. Distinct
// from DX_V2_STATUS so the standalone sidebar's editor rail doesn't
// accidentally open an "update Dx v2" sheet for a row that isn't in Dx
// v2 yet (staged-add) or already has a pending staged update (dedup).
// Payload `{ captured, dxv2Record }` — `dxv2Record` is null for
// staged-add rows, populated for staged-update rows so re-edit can
// fall back to the original Dx v2 seeds.
export const DX_V2_EDIT_CAPTURED = "dx-v2:edit-captured";
